import { MatPaginatorIntl } from '@angular/material/paginator'

export function CustomPaginator () {
  const customPaginatorIntl = new MatPaginatorIntl()

  customPaginatorIntl.itemsPerPageLabel = 'Quantidade por página:'

  return customPaginatorIntl
}
